import React, { useEffect, useState } from "react";
import DataTableElement from "../../../components/elements/DataTableElement";
import CustomButtonOval from "../../../components/form/CustomButtonOval";
import { useParams } from "react-router-dom";
import { paymentsResource } from "../../../helpers/configRoutes/backend_helper";
import { currencyUSD } from "../../../helpers/forms/formater";
import PreviewPDF from "../../../components/modal/PreviewPdf";

const PaymentDetail = () => {
    const { id } = useParams();

    const cols = [
        {
            id: "id",
            name: "ID",
            selector: (row) => row.id,
        },
        {
            id: "name",
            name: "CLIENT",
            selector: (row) => row.client?.contact_name,
        },
        {
            id: "company",
            name: "COMPANY",
            selector: (row) => row.client?.name,
        },

        {
            id: "period_start_at",
            name: "period start",
            selector: (row) => row.period_start_at,
        },
        {
            id: "period_end_at",
            name: "Period end",
            selector: (row) => row.period_end_at,
        },
        {
            id: "total",
            name: "PAYMENT",
            selector: (row) => currencyUSD(row.total),
        },
        {
            id: "paymentMethod",
            name: "PAYMENT METHOD",
            selector: (row) => row.paymentMethod?.name,
        },
    ];

    const colsSecTable = [
        {
            id: "id",
            name: "ID",
            selector: (row) => row.id,
        },
        {
            id: "description",
            name: "Description",
            selector: (row) => row.description,
        },
        
        {
            id: "card",
            name: "Card",
            selector: (row) => row.method_number,
        },
        {
            id: "base",
            name: "Base Cost",
            selector: (row) => currencyUSD(row.base),
        },
        {
            id: "Taxes",
            name: "Taxes",
            selector: (row) => currencyUSD(row.taxas),
        },
        {
            id: "total",
            name: "Total Cost",
            selector: (row) =>
                new Intl.NumberFormat("en-US", {
                    style: "currency",
                    currency: "USD",
                }).format(row.total),
        },
    ];

    const [tableLoad, setTableLoad] = useState({
        show: false,
        textLoad: "Loading invoice...",
    });
    const [data, setData] = useState([]);
    const [payment, setPayment] = useState({});
    const [paymentDetails, setPaymentDetails] = useState([]);
    const [modalPdf, setModalPdf] = useState({ show: false, url: "" });

    useEffect(() => {
        const getPayments = async () => {
            setTableLoad((prev) => ({ ...prev, show: true }));
            const response = await paymentsResource("show", {}, id);
            if (response?.payment) {
                setData([response.payment]);
                setPayment(response.payment);
                setPaymentDetails([response.payment])
            }
            setTableLoad((prev) => ({ ...prev, show: false }));
        };
        getPayments();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const getPdfDetailFile = async (sendEmail) => {
        const response = await paymentsResource("show", {
            params: { pdf: true, sendEmail:sendEmail || '' },
        }, id);

        if (!sendEmail && response.pdf) {
            setModalPdf({ show: true, url: response.pdf });
        }
        // si sendEmail es true, asumimos que el back envía el correo, no cambiamos flujo
    };

    const client = payment.client || {};
    const pm = payment.paymentMethod || {};

    return (
        <>
            <div className="min-h-screen bg-cs-bg-alt py-8 px-4">
                <div className="max-w-auto mx-auto space-y-4">
                    {/* Page header */}
                    <div className="flex flex-col md:flex-row md:items-center md:justify-between gap-2">
                        <div>
                            <p className="text-[10px] uppercase tracking-[0.18em] text-cs-muted">
                                Billing center
                            </p>
                            <h1 className="text-2xl font-semibold text-cs-dark">
                                Invoice detail
                            </h1>
                            <p className="text-sm text-cs-muted mt-1">
                                Review payment information, line items and generate the PDF invoice.
                            </p>
                        </div>
                        <div className="flex flex-col items-start md:items-end text-[9px] text-cs-muted">
                            <span>
                                Invoice ID:{" "}
                                <span className="font-semibold text-cs-primary-dark">
                                    {payment.id || "-"}
                                </span>
                            </span>
                            <span>
                                Status:{" "}
                                <span className="px-2 py-0.5 rounded-full bg-cs-primary-soft text-cs-primary-dark text-[8px]">
                                    Paid
                                </span>
                            </span>
                        </div>
                    </div>

                    {/* Invoice card */}
                    <div className="w-full bg-cs-bg rounded-2xl shadow-sm border border-cs-border overflow-hidden">
                        {/* Top section */}
                        <div className="px-6 py-5 bg-cs-surface flex flex-col md:flex-row gap-4 md:gap-6 justify-between">
                            {/* From */}
                            <div>
                                <h3 className="text-[10px] uppercase tracking-[0.14em] text-cs-muted mb-1">
                                    Invoice from
                                </h3>
                                <p className="text-[11px] font-semibold text-cs-dark">
                                    CargoSmart / Your Company
                                </p>
                                <p className="text-[9px] text-cs-muted">
                                    9694 Krajcik Locks Suite 635
                                </p>
                            </div>

                            {/* To */}
                            <div>
                                <h3 className="text-[10px] uppercase tracking-[0.14em] text-cs-muted mb-1">
                                    Invoice to
                                </h3>
                                <p className="text-[11px] font-semibold text-cs-dark">
                                    {client.name || "-"}
                                </p>
                                <p className="text-[9px] text-cs-muted">
                                    {client.contact_name || ""}
                                </p>
                                <p className="text-[9px] text-cs-muted">
                                    {client.email || ""}
                                </p>
                            </div>

                            {/* Dates & PM */}
                            <div className="text-[9px] text-cs-muted space-y-1">
                                <p>
                                    <span className="font-medium text-cs-dark">
                                        Invoice date:
                                    </span>{" "}
                                    {payment.created_at || "-"}
                                </p>
                                <p>
                                    <span className="font-medium text-cs-dark">
                                        Due date:
                                    </span>{" "}
                                    {payment.created_at || "-"}
                                </p>
                                <p>
                                    <span className="font-medium text-cs-dark">
                                        Payment method:
                                    </span>{" "}
                                    {pm.name || "-"}
                                </p>
                            </div>
                        </div>

                        {/* Main summary table */}
                        <div className="px-4 py-3">
                            <DataTableElement
                                columns={cols}
                                items={data}
                                tableLoad={tableLoad}
                            />
                        </div>

                        {/* Line items table */}
                        <div className="px-4 pb-4">
                            <div className="mt-3 mb-1 flex items-center justify-between">
                                <h3 className="text-[11px] font-semibold text-cs-dark">
                                    Line items
                                </h3>
                                <span className="text-[8px] text-cs-muted">
                                    Details of this invoice
                                </span>
                            </div>
                            <DataTableElement
                                columns={colsSecTable}
                                items={paymentDetails || []}
                                tableLoad={tableLoad}
                                classHead="bg-cs-surface-alt"
                            />
                        </div>

                        {/* Totals + Actions */}
                        <div className="px-4 md:px-6 py-4 border-t border-cs-border flex flex-col md:flex-row items-start md:items-center justify-between gap-3">
                            <div className="text-[10px] text-cs-muted">
                                <p>
                                    Subtotal:{" "}
                                    <span className="font-medium text-cs-dark">
                                        {currencyUSD(payment.subtotal || payment.total || 0)}
                                    </span>
                                </p>
                                {payment.taxes && (
                                    <p>
                                        Taxes:{" "}
                                        <span className="font-medium text-cs-dark">
                                            {currencyUSD(payment.taxes)}
                                        </span>
                                    </p>
                                )}
                                <p className="text-[11px] font-semibold text-cs-dark mt-1">
                                    Total:{" "}
                                    <span className="text-cs-primary">
                                        {currencyUSD(payment.total || 0)}
                                    </span>
                                </p>
                            </div>

                            <div className="flex flex-wrap gap-2 md:justify-end">
                                {/* Print / View PDF */}
                                <CustomButtonOval
                                    loading={tableLoad.show}
                                    textLoad={tableLoad.textLoad}
                                    className="
                                        px-3 py-1.5 rounded-xl
                                        bg-cs-bg-alt
                                        text-[9px] text-cs-muted
                                        border border-cs-border
                                        hover:bg-cs-primary-soft
                                        hover:text-cs-primary
                                        inline-flex items-center gap-1.5
                                    "
                                    onClick={() => getPdfDetailFile(false)}
                                >
                                    <span className="material-symbols-outlined text-[14px]">
                                        picture_as_pdf
                                    </span>
                                    View PDF
                                </CustomButtonOval>

                                {/* Send by email */}
                                <CustomButtonOval
                                    loading={tableLoad.show}
                                    textLoad={tableLoad.textLoad}
                                    className="
                                        px-3 py-1.5 rounded-xl
                                        bg-cs-primary
                                        text-[9px] text-white
                                        hover:bg-cs-primary-hover
                                        inline-flex items-center gap-1.5
                                        shadow-sm hover:shadow-md
                                    "
                                    onClick={() => getPdfDetailFile(true)}
                                >
                                    <span className="material-symbols-outlined text-[14px]">
                                        send
                                    </span>
                                    Send by email
                                </CustomButtonOval>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            {modalPdf.show &&
                <PreviewPDF modal={modalPdf} setModal={setModalPdf} />
            }
        </>
    );
};

export default PaymentDetail;
